<ng-container *ngIf="action !== 'requestRegistrationList'">
	<app-form-view [popup]="true">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="add-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch"
						fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100"
								fxLayoutGap="10px" fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="15px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData"
											[config]="config" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="formObjectReader($event)"></app-form-group>
									</div>

									<app-alert id="registrationWorkflowAlert"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center"
										fxLayoutGap="10px">

										<ng-container *ngIf="action === 'register' || action === 'addRegistration'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
												class="submit-btn" type="button">{{locale.translate('submit')}}</button>
										</ng-container>

										<ng-container *ngIf="action === 'requestRegistration'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
												class="submit-btn" type="button">{{locale.translate('submit')}}</button>
										</ng-container>

										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
											class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'requestRegistrationList'">
	<app-form-view [popup]="'true'" [button]="buttonOptions" (action)="addRegistration($event,'addRegistration')">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="request-register-listing" fxLayout="row" fxLayoutAlign="center center">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" fxLayout.xs="column"
					fxLayoutAlign.xs="start stretch" fxFlex="95" fxFlex.xs="100%">
					<div fxLayout="column" fxLayoutAlign="start stretch">
						<mat-tab-group class="custom-tab"
							[ngClass]="{'responsive-tab': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"
							mat-align-tabs="center" [selectedIndex]="tabIndex" (selectedIndexChange)="tabChange($event)"
							#tab>
							<mat-tab [label]="locale.translate('registrations')">
								<ng-container *ngIf="tabIndex === 0">
									<ng-container [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{data: {}}">
									</ng-container>
								</ng-container>
							</mat-tab>
							<mat-tab [label]="locale.translate('requests')">
								<ng-container *ngIf="tabIndex === 1">
									<ng-container [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{data: {}}">
									</ng-container>
								</ng-container>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>

</ng-container>

<ng-template #list let-data="data">
	<div class="request-list-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="6px">
		<div class="request-list-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="34px">
			<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxLayout.xs="column"
				fxLayoutAlign.xs="start stretch">
				<div fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch">
					<ng-container *ngIf="requestList?.length === 0 && !loader && !controlValue">
						<div class="no-data" fxLayoutAlign="center center">
							<ng-container *ngIf="tabName === 'registration'">
								<p>
									{{locale.translate('no_registrations_yet')}}
								</p>
							</ng-container>
							<ng-container *ngIf="tabName === 'requests'">
								<p>
									{{locale.translate('no_requests_pending')}}
								</p>
							</ng-container>

						</div>
					</ng-container>
					<ng-container *ngIf="requestList?.length || (!requestList?.length && controlValue)">
						<div class="search-form" fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1"
							fxFlex.xs="auto">
							<div fxLayout="row" fxLayoutAlign="start stretch" fxFlex="1 1" fxFlex.xs="auto"
								#formElement>
								<app-form-group [fieldList]="formFields" [config]="config"
									(formObject)="formObjectReader($event)" (search)="searched()" (clear)="clear()">
								</app-form-group>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="request-list-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<loader [loader]="loader" [type]="'general'"></loader>
				<ng-container *ngIf="requestList?.length === 0 && !loader && controlValue">
					<div class="no-data" fxLayout="row" fxLayoutAlign="center center">
						<p>
							{{locale.translate('nothing_to_show')}}
						</p>
					</div>
				</ng-container>
				<ng-container *ngIf="requestList?.length">
					<app-common-list [layout]="'column'" [layoutGap]="'20px'" [count]="requestCount" [pageSize]="limit"
						type="pagination" (pagination)="pagination($event)">
						<list-item
							*ngFor="let request of requestList; let i = index; trackBy: gfService.trackByID.bind({'key': 'requestID'})">
							<content-area class="request-list-item" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="24px">
								<!-- <app-chips type="legend" (title)="searchPeopleDetail(user)"
									[data]="{imageSrc: user?.profilePicURL, title: user.name, shortInfo: user?.shortInfo}">
								</app-chips> -->

								<div class="users" [ngClass]="{ 'processing': request?.deleting}" fxLayout="row"
									fxLayoutAlign="start start" fxLayoutGap="10px"
									(click)="searchPeopleDetail(request)">
									<div class="user-pic" fxFlex="0 0 40px">
										<ng-container
											*ngIf="![null, undefined, ''].includes(request?.user?.profilePicURL)">
											<img [src]="request?.user?.profilePicURL"
												(error)="gfService.setErrorImage($event, 'man')">
										</ng-container>
										<ng-container
											*ngIf="[null, undefined, ''].includes(request?.user?.profilePicURL)">
											<img src="assets/img/man.png">
										</ng-container>
									</div>
									<div class="cm-right-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
										fxLayoutAlign="start stretch" fxLayoutGap="4px">
										<div class="user-details" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayoutGap="0px">
											<div class="user-info" fxLayout="row wrap"
												fxLayoutAlign="space-between center" fxFlex="0 0 auto">
												<div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutGap.xs="1px">
													<span class="entity-title linkable">{{request?.name}}</span>
												</div>
												<div fxLayoutAlign="center center">
													<ng-container *ngIf="request?.requestStatus">
														<div class="sub-txt-patch"
															[ngClass]="{'success': (request?.status === 2 && tabName === 'registration')}">
															{{ request?.requestStatus }}
														</div>
													</ng-container>
												</div>
											</div>

											<div class="user-info" fxLayout="row wrap"
												fxLayoutAlign="space-between center" fxFlex="0 0 auto">
												<div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutGap.xs="1px">
													<ng-container
														*ngFor="let data of request?.shortInfo; let isLast = last">
														<span class="sub-text-1">{{data?.value}}</span>
														<ng-container *ngIf="!isLast">
															<span>|</span>
														</ng-container>
													</ng-container>

												</div>
												<ng-container *ngIf="tabName === 'requests' && request?.status === 0">
													<div class="button-block" fxLayout="row"
														fxLayoutAlign="center center" fxLayoutGap="10px">
														<button mat-button class="sub-action-btn-2" type="button"
															#actionEl [disabled]="request?.load"
															(click)="updateRequest('approve',request,{index:i, actionElement: actionEl})">
															{{ locale.translate('approve') }}
														</button>
														<button mat-button class="sub-action-btn-2" type="button"
															#actionEl [disabled]="request?.load"
															(click)="alertPopup('decline',request,{index:i, actionElement: actionEl})">
															{{ locale.translate('decline') }}
														</button>
													</div>
												</ng-container>
											</div>

										</div>
										<div class="overfiew" fxLayout="row" fxLayoutAlign="start center"
											fxLayoutGap="10px">
											<span class="date-item">{{request?.date}}</span>
										</div>
									</div>
								</div>
							</content-area>
						</list-item>
					</app-common-list>
				</ng-container>
			</div>
		</div>
	</div>
</ng-template>
